import SummaryTranslationMapper from "../../core/service/translations/SummaryTranslationMapper";
import { formatBooleanValue } from "../../util";
import LegalView from "../model/LegalView";

const LegalViewMapper = (item: any) => {
  let legalView = LegalView(item);
  legalView.valid = formatBooleanValue(item?.valid);
  legalView.summaryTranslations = (item.summaryTranslations || []).map((elem) =>
    SummaryTranslationMapper(elem)
  );
  return legalView;
};

export default LegalViewMapper;
